export const isNew = window.location.href.includes('lexus_new_web')

export const nameSpace = ''
export const myName = isNew ? 'lexus_new_web' : 'lexus_web'

const productionBaseUrl = (window.location.origin + window.location.pathname).split(myName)[0]
export const ajaxBaseUrl = process.env.NODE_ENV !== 'production' ? '' : `${productionBaseUrl}${isNew ? `lexus_new_web` : 'lexus_mini_web'}`

export const iframeBaseUrl = process.env.NODE_ENV !== 'production' ? '' : productionBaseUrl

export const jsonPath = `${ajaxBaseUrl}/${nameSpace}data`
